<template>
  <div class="site-footer">
    <div class="container site-footer-cont">
      <div class="row">
        <div class="col-md-4 footer-col d-none d-md-block">
          <div class="footer-map">
            <iframe
              class="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3926.9311355234063!2d-67.94867711429542!3d10.18624799683708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e8069960d0f20e1%3A0x83c0b95e638853a5!2sWMS%20Venezuela!5e0!3m2!1ses-419!2sve!4v1576712446730!5m2!1ses-419!2sve"
              width="600"
              height="450"
              frameborder="0"
              style="border:0;"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <div class="col-md-4">
          <div class="footer-address">
            <h3 class="contactanos-title">Contáctanos</h3>
            <ul>
              <li>
                <img src="@/assets/images/phone.jpg" alt="Phone icon" />
                <span>0424 - 4376029 / 0424 - 4923442</span>
              </li>
              <li>
                <img src="@/assets/images/email.jpg" alt="Email icon" />
                <span>info@wmsvezuela.com</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-4 footer-col">
          <div id="contact">
            <form @submit.prevent="">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  aria-label="Nombre"
                  placeholder="Nombre"
                />
              </div>
              <div class="form-group">
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  area-label="Email"
                  placeholder="E-mail"
                />
              </div>
              <div class="form-group">
                <textarea
                  class="form-control"
                  id="mensaje"
                  rows="3"
                  placeholder="Mensaje"
                  aria-label="Mensaje"
                ></textarea>
              </div>
              <button
                type="submit"
                class="btn btn-secondary ml-auto float-right"
              >
                Enviar
              </button>
            </form>
          </div>
        </div>
        <div class="col-md-4 footer-col d-none d-md-block"></div>
      </div>
    </div>
    <div class="copyright text-white">
      <p class="mb-0 text-center">WMS de Venezuela S.A. &copy; 2020</p>
      <p class="mb-0 text-center">
        <small>
          Diseñado por
          <a
            href="https://www.instagram.com/jotaestudiocreativo/"
            target="blank"
            >Jota Estudio Creativo</a
          >. Desarrollado por
          <a href="https://nampil.dev" target="blank">Nampil</a>
        </small>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SiteFooter'
}
</script>
<style lang="scss" scoped>
.site-footer {
  padding-top: 40px;
  background-color: #f2f2f2;
}
.map {
  width: 100%;
  max-height: 200px;
}
.footer-col {
  margin-bottom: 20px;
}
.footer-address {
  ul {
    margin-top: 1rem;
    li {
      line-height: 26px;
      display: flex;
      margin: 5px 0;

      img {
        margin-right: 10px;
        vertical-align: center;
        align-self: center;
      }
      span {
        line-height: 26px;
      }
    }
  }
  .contactanos-title {
    background-color: #000;
    display: inline;
    padding: 5px 10px;
    text-transform: uppercase;
    color: #fff;
    font-family: 'Aurulent Sans', sans-serif;
    font-size: 1rem;
  }
}
.copyright {
  font-size: 0.75rem;
  background-color: $azul;
  a {
    color: $primary;
  }
}
</style>
